import { JsonLd } from 'gatsby-plugin-next-seo'
import React from 'react'

interface ImageObject {
  src: string
  href?: string
  alt?: string
  label?: string
}

interface Props {
  itemList: ImageObject[] | undefined
  name: string
}

const ImageListSchema = (props: Props) => {
  const { itemList, name } = props

  return (
    <JsonLd
      json={{
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: name ?? '',
        itemListElement: itemList?.map((item, index) => {
          return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'ImageObject',
              contentUrl: item?.src,
              url: item?.src,
              name: item?.alt,
              description: item?.alt,
            },
          }
        }),
      }}
    />
  )
}

export default ImageListSchema
